import React from 'react'

import type { Form } from 'factorial-form'
import moment from 'moment'

import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/Inputs/DayPicker'
import i18n from 'modules/core/lib/i18n'

interface Props {
  isEligibleForPayroll: boolean
  form: Form
}

function TerminateDaypicker({ form, isEligibleForPayroll }: Props) {
  const today = moment()
  const minDate = today.clone().subtract(2, 'days')
  const maxDate = today.clone().add(3, 'month')

  let dayPickerAttributes: React.ComponentProps<typeof DayPicker> = {
    label: i18n.t('employees.termination.termination_date'),
    field: form.get('terminated_on'),
    pin: true,
    mandatory: true,
  }

  if (isEligibleForPayroll) {
    dayPickerAttributes = { ...dayPickerAttributes, minDate, maxDate }
  }

  return <DayPicker {...dayPickerAttributes} />
}

export default observer(TerminateDaypicker)
